import React from "react";
import { Link } from "react-router-dom";
import FormInput from "../../Forms/FormInput";
import FormTextArea from "../../Forms/FormTextArea";
import Icon from "../../Icon";

const ContactHome = () => {

    const handleFolio = (name) =>{
        window.open(name, '_blank');
    }

    return (
        <div className="contacts" id='contacts'>
            <div className="contacts-body grid2">
                <div className="form-contacts">
                    <h2 className="contact-title">Un message pour nous ?</h2>
                    <p className="contact-para">Vous avez une question, un projet? Nous serions ravis de discuter...</p>
                    <form action="" className="form-contact">
                        <div className="form-group-contact">
                            <div>
                                <FormInput 
                                    placeholder='Nom'
                                    type="text"
                                    className="trans-input"
                                />
                            </div>
                            <div>
                                <FormInput
                                    tpe='email'
                                    placeholder='E-mail'
                                    className="trans-input"
                                />
                            </div>
                        </div>
                        <div className="form-spacing-contact">
                            <FormInput 
                                placeholder='Objet'
                                type='text'
                                className="trans-input"
                            />
                        </div>
                        <div className="form-spacing-contact">
                            <FormTextArea 
                                placeholder='Message'
                                className="trans-input"
                            />
                        </div>
                    </form>
                </div>
                <div className="contacts-map">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13441.602943296042!2d-7.918262465587424!3d12.603469213586417!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xe51d3fc2e6c68e9%3A0xf8e44ef8b0645b0!2sSanSOFTIC!5e0!3m2!1sfr!2sml!4v1629765664898!5m2!1sfr!2sml" allowFullScreen="" loading="lazy" style={{border: 0}}></iframe>
                </div>
            </div>
            <div className="contacts-head">
                <div className="contacts-head-item">
                    <div><span className="contacts-link" onClick={()=>handleFolio('tel:0022391923237')} ><Icon name="phone" className="icon" /> <span>+ (223) 91 92 32 37</span></span></div>
                    <p>
                    Appelez-nous au numéro ci-dessus pour obtenir une solution rapide. Des frais supplémentaires peuvent s'appliquer
                    </p>
                </div>
                <div className="contacts-head-item">
                    <div><span className="contacts-link" onClick={()=>handleFolio('mailto:sibrahima250@gmail.com')}><Icon name="envelop"/> <span>ib@sansoftic.net</span></span></div>
                    <p>
                    Pour les questions générales et les questions, y compris les opportunités de partenariat
                    </p>
                </div>
                <div className="contacts-head-item">
                    <div><Link to='' ><Icon name="map"/> <span>Yirimadjo kodjalani</span></Link></div>
                    <p>
                    Si vous avez des questions techniques, discutez en direct avec les développeurs dans notre chat Skype
                    </p>
                </div>
                <div className="contacts-head-item">
                    <div><span className="contacts-link" onClick={()=>handleFolio('https://ibfolio.sansoftic.net')}><Icon name="user-form"/> <span>ibfolio.sansoftic.net</span></span></div>
                    <p>
                    Carrières et questions liées à la presse s'il vous plaît écrivez-nous à l'adresse ci-dessus
                    </p>
                </div>
            </div>
            
        </div>
    )
}

export default ContactHome;